import { render, staticRenderFns } from "./WebcamStreamFace.vue?vue&type=template&id=67e70635"
import script from "./WebcamStreamFace.vue?vue&type=script&lang=js"
export * from "./WebcamStreamFace.vue?vue&type=script&lang=js"
import style0 from "./WebcamStreamFace.vue?vue&type=style&index=0&id=67e70635&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports